import React, { useEffect } from 'react';
import { useScreenInit } from '../useScreenInit';
import { HeroV2 } from '../components/HeroV2';
import { PartnerLogos } from '../components/PartnerLogos';
import { Stats } from '../components/Stats';
import { Services } from '../components/Services';
import { SystemsWeInstall } from '../components/SystemsWeInstall';
import { Advantages } from '../components/Advantages';
import { Testimonial } from '../components/Testimonial';
import { News } from '../components/News';
import { QuoteForm } from '../components/QuoteForm';
export function HomeV2() {
  const screenInit = useScreenInit();
  return <main id="main-content" data-id="element-1219">
      <HeroV2 data-id="element-1220" />
      <PartnerLogos data-id="element-1221" />
      <Stats data-id="element-1222" />
      <Services data-id="element-1223" />
      <SystemsWeInstall data-id="element-1224" />
      <Advantages data-id="element-1225" />
      <Testimonial data-id="element-1226" />
      <News data-id="element-1227" />
      <QuoteForm data-id="element-1228" />
    </main>;
}